import * as Yup from "yup";

const servicoValidator = Yup.object().shape({
  nome: Yup.string().required("Nome"),
  descricao: Yup.string().required("Descrição"),
  grupoServicoId: Yup.number().required("Grupo de Serviço"),
  grupoTributarioId: Yup.number().nullable(),
  estCodigoServicoNacionalId: Yup.number().nullable(),
  estClassificacaoServicoNacionalId: Yup.number().nullable(),
  aliquotaTotalSimplesNacional: Yup.number().nullable(),
  precoServico: Yup.mixed().test(
    "is-number",
    "Preco de serviço maior que zero",
    (value) => value && !isNaN(Number(value)) && Number(value) > 0,
  ),
  prazoRecorrencia: Yup.number().when(
    "servicoRecorrente",
    (servicoRecorrente) => {
      return servicoRecorrente
        ? Yup.number().required("Prazo de Recorrência")
        : Yup.number().nullable().optional();
    },
  ),
});

export default servicoValidator;
